import { Pipe, PipeTransform } from '@angular/core';
import { GetNotesTemplateTranslationsDto, GetNotesTypeTranslationsDto } from '@modeso/types__aumico-lib-notes-be';
import {
    GetAccountingBasisTranslationDto,
    GetFinancialLineItemTranslationDto,
    GetLegalFormTranslationDto,
} from '@modeso/types__aumico-lib-settings-be';
import { GetGroupTranslationsDto } from '@modeso/types__aumico-lib-templates-be';
import { EMPTY_STRING } from '../constants/constants';

type TranslationItem =
    | GetAccountingBasisTranslationDto
    | GetNotesTypeTranslationsDto
    | GetNotesTemplateTranslationsDto
    | GetLegalFormTranslationDto
    | GetGroupTranslationsDto
    | GetFinancialLineItemTranslationDto;
@Pipe({
    name: 'translationsFormFilter',
})
export class TranslationsFormFilterPipe implements PipeTransform {
    transform(arrayOfTranslations: TranslationItem[], searchFilter: string): TranslationItem[] {
        if (searchFilter == null || searchFilter.trim() === EMPTY_STRING) {
            return arrayOfTranslations;
        }
        const searchFilterTrimmedAndInLowerCase = searchFilter.trim().toLowerCase();
        return [
            ...arrayOfTranslations.filter((value) => {
                if ('text' in value) {
                    return (
                        value['name'].toLowerCase().includes(searchFilterTrimmedAndInLowerCase) ||
                        value['text']['de-ch']?.toLowerCase().includes(searchFilterTrimmedAndInLowerCase)
                    );
                } else if ('title' in value) {
                    return (
                        value.name.toLowerCase().includes(searchFilterTrimmedAndInLowerCase) ||
                        value.title['de-ch']?.toLowerCase().includes(searchFilterTrimmedAndInLowerCase)
                    );
                } else if ('description' in value) {
                    return (
                        value['name'].toLowerCase().includes(searchFilterTrimmedAndInLowerCase) ||
                        value['description']['de-ch']?.toLowerCase().includes(searchFilterTrimmedAndInLowerCase)
                    );
                }
                return value.name.toLowerCase().includes(searchFilterTrimmedAndInLowerCase);
            }),
        ];
    }
}
